import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { RemoteService } from 'app/services/remote.service';
import { Observable, timer } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { STATUS_CONSTANTS } from "app/services/STATUS_CONSTANTS";
import { LocalStorageService } from 'ngx-store';
import { Router } from '@angular/router';
import { SelectAutocompleteComponent } from 'mat-select-autocomplete';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  signup: FormGroup;
  countries = [];
  exchange = [];
  hide = true;
  TimeCounter: Observable<number>;
  count = 120;
  showCheildAddOpt: boolean = false;
  showAddOption: boolean = true;
  formSumitAttempt: boolean;
  otpShow: boolean;
  currencyArray: any[];
  selectedOptions = [];
  selected = this.selectedOptions;
  @ViewChild(SelectAutocompleteComponent) multiSelect: SelectAutocompleteComponent;
  showMessageMatchedPwd: string;
  constructor(private fb: FormBuilder,
    private notifierService: NotifierService,
    private remoteService: RemoteService,
    private ls: LocalStorageService,
    private router: Router) { }

  ngOnInit() {
    this.TimeCounter = timer(0, 1000).pipe(
      take(this.count),
      map(() => --this.count)
    );
    this.signup = this.fb.group({
      email: ['', [Validators.required, Validators.pattern('^[a-z0-9A-Z.!#$%^&+;*_)(-]{3,}[@]{1}[a-z]{2,}[.]{1}[a-z]{2,}$')]],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
      // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&#^])[A-Za-z\\d@$!%*?&#^]{6,}$')]],
      // country: new FormControl([Validators.required]),
      // exchange: ['', [Validators.required]],
      // currency: ['', [Validators.required]],
      country: new FormControl(),
      currency: [''],
      exchange: [''],
      firstName: [''],
      lastName: [''],
      address: [''],
      phoneNumber: [''],
      organisationName: ['']
      // otp: ''
    });
    if (this.ls.get('access_token')) {
      return this.remoteService.userNavigateTodashboard();
    }
    this.countryList();
    this.remoteService.scrollingtoNavbar();
  }

  signUp() {
    if (this.showMessageMatchedPwd == "Not matched") {
      return this.notifierService.notify('error', 'The passwords you entered did not match.');
    }
    if (this.signup.valid) {
      const payload = {
        email: this.signup.value.email,
        password: (this.signup.value.password).trim(),
        username: this.signup.value.email,
        // currency: this.signup.value.currency,
        currency: 'CAD',
        // countries: this.signup.value.country,
        countries: [
          'Canada',
          'USA',
        ],
        // exchanges: this.signup.value.exchange,
        exchanges: [
          'TSX',
          'TSXV',
          'NASDAQ',
          'NYSE',
        ],
        // firstname: this.signup.value.firstName,
        firstname: 'First',
        // lastname: this.signup.value.lastName,
        lastname: 'Last',
        address: this.signup.value.address,
        phoneNumber: this.signup.value.phoneNumber,
        organisationName: this.signup.value.organisationName
      }
      this.remoteService.signup(payload).subscribe(res => {
        if (res) {
          const data = {
            text: 'Click on link sent to your email to complete the signup',
            type: '',
            link: "/home"
          }
          this.remoteService.openSweetAlert(data);
        }
      }, error => {
        const data = {
          text: error.error.message,
          type: 'warning'
        }
        this.remoteService.openSweetAlert(data)
      })
      this.otpShow = true;
      this.TimeCounter = timer(0, 1000).pipe(
        take(this.count),
        map(() => --this.count)
      );
    } else {
      this.otpShow = false;
      this.notifierService.notify('error', 'Invalid Inputs');
    }

  }

  resendOtp() {
    this.count = 120;
    this.TimeCounter = timer(0, 1000).pipe(
      take(this.count),
      map(() => --this.count)
    );
  }

  otpValid() {
    if (this.signup.get('otp').valid) {

    } else {

    }
  }

  selectedCountry(selected) {
    this.selected = selected;
    const value = (selected).toString();
    this.countryExchangeList(value);
  }

  isFieldValid(field: string) {
    return (!this.signup.get(field).valid && this.signup.get(field).touched ||
      this.signup.get(field).untouched && this.formSumitAttempt);
  }

  onSubmit() {
    this.formSumitAttempt = true;
  }

  countryList() {
    const payLoad = {
      searchString: '',
      pageIndex: 0,
      pageSize: 500
    }
    this.remoteService.getCountriesList(payLoad).subscribe(res => {
      if (res) {
        res.sort().map((element, i) => {
          this.countries.push({ display: element, value: element });
        })
      }
    }, error => {
      this.remoteService.errorFunction(error);
    })
  }

  countryExchangeList(query) {
    if (query.length > 0) {
      this.remoteService.getCountryExchangeList(query).subscribe(res => {
        if (res) {
          this.exchange = JSON.parse(res);
          this.selectedExchange();
          var arrayExchangeData = this.signup.value.exchange;
          if (arrayExchangeData) {
            if (arrayExchangeData.length > 0) {
              var arrayExchange = [];
              this.exchange.forEach(ref => {
                arrayExchangeData.forEach(element => {
                  if (ref.symbol == element) {
                    arrayExchange.push(ref.symbol)
                  }
                });
              });
              this.signup.patchValue({ exchange: arrayExchange });
            }
          }
        }
      }, error => {
        this.signup.patchValue({ exchange: null });
        this.exchange = [];
        if (error != null) {
          this.remoteService.errorFunction(error);
        }
      })
    } else {
      this.signup.patchValue({ exchange: null });
      this.exchange = [];
    }
  }

  isJsonError(err) {
    try {
      JSON.parse(err);
    } catch (e) {
      return false;
    }
    return true;
  }

  firstClick() {
    this.showCheildAddOpt = true;
    this.showAddOption = false;
  }

  secondClick() {
    this.showCheildAddOpt = false;
    this.showAddOption = true;
  }

  selectedExchange() {
    this.currencyArray = [];
    var uniqueArray = [];
    var exchangedata = [];
    exchangedata = this.signup.value.exchange;
    if (exchangedata) {
      if (exchangedata.length > 0) {
        this.exchange.forEach(res => {
          exchangedata.forEach(element => {
            if (res.symbol == element) {
              uniqueArray.push(res.currency_symbol);
            }
          });
        })
        this.currencyArray = Array.from(new Set(uniqueArray));
      } else {
        this.currencyArray = []
      }
    }
  }

  removeSpaces() {
    if ((this.signup.value.password).trim() === '' || (this.signup.value.password).trim() === null || (this.signup.value.password).trim() === undefined) {
      this.signup.patchValue({ password: (this.signup.value.password).trim() });
    }
    if ((this.signup.value.confirmPassword).trim() === '' || (this.signup.value.confirmPassword).trim() === null || (this.signup.value.confirmPassword).trim() === undefined) {
      this.signup.patchValue({ confirmPassword: (this.signup.value.confirmPassword).trim() });
    }
  }

  keyupPassword() {
    if (this.signup.value.password !== undefined && this.signup.value.password !== '' &&
      this.signup.value.password !== null && this.signup.value.confirmPassword !== undefined &&
      this.signup.value.confirmPassword !== '' && this.signup.value.confirmPassword !== null) {
      if (this.signup.value.password == this.signup.value.confirmPassword) {
        this.showMessageMatchedPwd = 'Matched password'
      } else {
        this.showMessageMatchedPwd = 'Not matched'
      }
    }
  }
}
